// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {Object} Attendance
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} uid
 * @property {string} membership
 * @property {string} organization
 * @property {string} startAt
 * @property {string} endAt
 */

const state = {
  /**
   * list of attendance records
   * for the current active organization
   * @type {Attendance[]}
   **/
  attendance: []
};

export default state;

/**
 * @param {state} state
 * @return {(uid: string) => Attendance[]}
 */
export function memberAttendance (state) {
  return uid => state.attendance.filter(a => a.uid === uid);
}
